import { ProxyCheckmark} from "./ProxyCheckmark";

export default ProxyCheckmark;
